export default class PaymentViewModel {
    constructor(data){
        this.kindId = data.kindId;
        this.viewName = data.viewName;
        this.paymentAt = data.paymentAt;
    }
}